/**
 * Trader API V1
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
export var RewardValue;
(function (RewardValue) {
    RewardValue.TypeEnum = {
        PointsFixed: 'points_fixed',
        PointsFixedUnitProduct: 'points_fixed_unit_product',
        PointsMultiplier: 'points_multiplier',
        DiscountBasketPercentageOff: 'discount_basket_percentage_off',
        DiscountBasketDollarsOff: 'discount_basket_dollars_off',
        DiscountProductsPercentageOff: 'discount_products_percentage_off',
        DiscountProductsDollarsOff: 'discount_products_dollars_off',
        DiscountProductsFixedPrice: 'discount_products_fixed_price',
        BogoPercentageOff: 'bogo_percentage_off',
        BogoDollarsOff: 'bogo_dollars_off',
        BogoFixedPrice: 'bogo_fixed_price',
        Unknown: 'unknown'
    };
})(RewardValue || (RewardValue = {}));
